import React from "react";
import "./ProjectsCard.css";

const ProjectsCard = ({ project }) => {
  const { title, desc, image, liveURL, codeURL, tech } = project;
  return (
    <div className="card m-4">
      <img src={image} className="card-img-top" alt="project" />
      <div className="card-body">
        <h4 className="card-title">{title}</h4>
        <p className="card-text">{desc}</p>
        {tech.map((tch) => (
          <span className="badge bg-secondary m-1" key={tch.id}>
            {tch.data}
          </span>
        ))}
      </div>
      <div className="card-body">
        <span>
          <a
            className="btn project-btn m-2"
            rel="noreferrer"
            target="_blank"
            href={liveURL}
          >
            Live Website
          </a>
        </span>
        <span>
          <a
            className="btn project-btn m-2"
            rel="noreferrer"
            target="_blank"
            href={codeURL}
          >
            Github Code
          </a>
        </span>
      </div>
    </div>
  );
};

export default ProjectsCard;
